import { mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('application', ['canInteract']),
  },

  methods: {
    ...mapMutations('application', ['allowInteraction', 'blockInteraction']),
  },
};
